import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=4b6e5fd2&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e5fd2",
  null
  
)

export default component.exports